import { render } from "./TaxeUtilaj.vue?vue&type=template&id=3447bec2&scoped=true"
import script from "./TaxeUtilaj.vue?vue&type=script&lang=js"
export * from "./TaxeUtilaj.vue?vue&type=script&lang=js"

import "./TaxeUtilaj.vue?vue&type=style&index=0&id=3447bec2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Radu Cosmin\\Desktop\\fcfaz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3447bec2"]])

export default __exports__